import { render } from "./BasicLayout.vue?vue&type=template&id=70187956"
import script from "./BasicLayout.vue?vue&type=script&lang=js"
export * from "./BasicLayout.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__